<template>
    <div>
        <Hero colour-index="1" title="Integrations Roadmap" subtitle="Tell us what integrations we need to add." />

        <div class="w-full my-12 px-3 sm:px-28">
            <form>
                <input ref="searchInput" type="text" id="voice-search"
                    class="search-bar text-md rounded-lg block w-full py-4 px-3" placeholder="Search..." required
                    v-model="search" />
            </form>
        </div>

        <div class="flex my-12 px-3 sm:px-28">
            <div class="lg:w-1/4 hidden lg:inline-block">
                <div class="mr-12">
                    <NuxtLink to="/integrations" class="btn text-sm w-full text-center btn-primary">See what's
                        available now</NuxtLink>
                </div>
            </div>
            <div
                class="lg:w-3/4 justify-top grid gap-4 w-full sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 content-start">
                <div v-for="i in INTEGRATIONS.filter((i) => !search || i.name.toLowerCase().includes(search.toLowerCase()))" class="">
                    <Integration :integration="(i as any)" :href="`/contact?i=${i.type}`" />
                </div>
            </div>
        </div>

        <Hero title="Unleash your full integration potential" colour-index="3" :buttons="[
            { link: 'https://app.unified.to', title: 'Get started' },
            { link: '/contact', title: 'Talk to our team', icon: 'ic:round-keyboard-arrow-right' },
        ]" subtitle="Sign up in seconds and start building integrations today." />
    </div>
</template>

<script setup lang="ts">
import { setTitle } from '~~/services/common';

setTitle(
    'Integrations Roadmap',
    'See the integrations on the Unified.to roadmap and tell us which ones to add next. Request any integration your customers need for HR, ATS, CRM, accounting, ticketing and more.'
);
</script>

<script lang="ts">
import ROADMAP from '~/data/roadmap.json';
import HomeSection from '~/components/HomeSection.vue';

export default {
    components: { HomeSection },

    data() {
        return {
            search: '',
            INTEGRATIONS: ROADMAP,
        };
    },
};
</script>
